import { render } from "./Player.vue?vue&type=template&id=967b7870"
import script from "./Player.vue?vue&type=script&lang=js"
export * from "./Player.vue?vue&type=script&lang=js"

import "./Player.vue?vue&type=style&index=0&id=967b7870&lang=css"

import exportComponent from "/var/www/zaytoon-frontend-base/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__